import styled from 'styled-components';
import { Flex, YellowButton } from 'UI';

export const SContainer = styled.div`
  display: flex;
  flex: 1;
  flex-basis: 690px;
  justify-content: center;
  max-width: 690px;
  height: 50px;
  border-radius: 25px;
  border: solid 1px ${({ theme }) => theme.color.silver_2};
`;

export const SContainerError = styled(Flex)<{ small?: boolean }>`
  z-index: 100;
  flex-basis: 690px;
  flex-wrap: wrap;
  max-width: 690px;
  height: ${({ small }) => (small ? 30 : 50)}px;
  border-radius: 25px;
  border: solid 1px ${({ theme }) => theme.color.pink_bright};
  background-color: ${({ theme }) => theme.color.palette_red_1};
`;

export const MagnifierButton = styled(YellowButton)`
  width: 60px;
  height: 50px;
  margin-right: -5px;
  margin-top: -1px;
  margin-left: 2px;
  border-radius: 0 25px 25px 0;
`;

export const DarkMagnifierButton = styled.button`
  width: 60px;
  height: 50px;
  margin-right: -5px;
  margin-top: -1px;
  margin-left: 2px;
  border-radius: 0 25px 25px 0;
  background: #000;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: #222;
  }
`;

export const FlexMenuContainer = styled(Flex)`
  border-radius: 8px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 5px 14px 4px ${({ theme }) => theme.color.shadow_10}, 0 2px 8px 0 ${({ theme }) => theme.color.shadow_6},
    0 2px 3px -2px ${({ theme }) => theme.color.shadow_5};
`;

export const SCountryMenuList = styled.div`
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const SCountryHeader = styled.div`
  padding: 12px 16px 6px;
  font-size: 13px;
  color: ${({ theme }) => theme.color.grey55};
  font-weight: 500;
`;

export const SCountryMenuItem = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  background: ${({ $selected, theme }) => ($selected ? theme.color.grey95 : 'transparent')};

  &:hover {
    background: ${({ theme }) => theme.color.grey95};
  }
`;

export const SCountryItemName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.color.grey15};
`;
